<template>
	<v-row>
		<v-col cols="12">
			<v-card class="pa-3 elevation-0 rounded-lg">
				<v-row>
					<v-col cols="12">
						<v-form ref="formProfile" role="form">
							<v-row>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Nama Lengkap" color="primary" class="input-regis" prepend-inner-icon="mdi-account" hide-details="auto" v-model="member_name" :disabled="!isEditing" :rules="rules.input"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Email" color="primary" class="input-regis" prepend-inner-icon="mdi-email" hide-details="auto" v-model="data.member_email" disabled></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Nomor Identitas" color="primary" class="input-regis" prepend-inner-icon="mdi-card-account-details" hide-details="auto" v-model="data.member_identity_no" disabled></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-menu v-model="joinDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field label="Tanggal Gabung" color="primary" class="input-regis" prepend-inner-icon="mdi-calendar-check" hide-details="auto" readonly v-bind="attrs" v-on="on" :value="convertDate(data.member_join_datetime)" disabled></v-text-field>
										</template>
										<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="joinDate = false" hide-details="auto" v-model="data.member_join_datetime"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Nomor Handphone" color="primary" class="input-regis" prepend-inner-icon="mdi-cellphone" hide-details="auto" v-model="data.member_mobilephone" disabled></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0 mt-4 mb-2 d-flex flex-column flex-md-row align-md-center justify-md-space-between">
									<v-card-subtitle class="py-0 px-0 grey--text lighten-5"><v-icon dense class="mr-2">mdi-account-cog-outline</v-icon>Jenis Kelamin</v-card-subtitle>
									<v-radio-group
										v-model="member_gender"
										row
										hide-details="auto"
										class="ml-md-5 pl-md-5 mt-4 mt-md-0 pt-0"
										:disabled="!isEditing"
										:rules="rules.input"
									>
										<v-radio
											label="Laki-laki"
											value="Laki-laki"
										></v-radio>
										<v-radio
											label="Perempuan"
											value="Perempuan"
										></v-radio>
									</v-radio-group>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Tempat Lahir" color="primary" class="input-regis" prepend-inner-icon="mdi-home-city" hide-details="auto" v-model="member_birth_place" :rules="rules.input" :disabled="!isEditing"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-menu v-model="bornDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field label="Tanggal Lahir" color="primary" class="input-regis" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" :value="convertDate(member_birth_date)" :rules="rules.input" :disabled="!isEditing"></v-text-field>
										</template>
										<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="bornDate = false" hide-details="auto" v-model="member_birth_date"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-autocomplete label="Provinsi" no-data-text="Tidak ada data" color="primary" class="input-regis" prepend-inner-icon="mdi-map-marker" :items="province" item-text="province_name" item-value="province_id" hide-details="auto" v-model="member_province_id" @change="changeProvince" :rules="rules.input" :disabled="!isEditing"></v-autocomplete>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-autocomplete label="Kabupaten / Kota" no-data-text="Pilih Provinsi Dahulu" color="primary" class="input-regis" prepend-inner-icon="mdi-map-marker" :items="city" item-text="city_name" item-value="city_id" hide-details="auto" v-model="member_city_id" :rules="rules.input" :disabled="!isEditing" ></v-autocomplete>
								</v-col>
								<v-col cols="12" sm="12" class="px-5">
									<v-textarea label="Alamat" color="primary" class="input-regis" prepend-inner-icon="mdi-map-marker-plus" rows="2" counter="255" maxlenght="255" no-resize hide-details="auto" v-model="member_address" :rules="rules.input" :disabled="!isEditing"></v-textarea>
								</v-col>
							</v-row>
						</v-form>
					</v-col>
				</v-row>
			</v-card>
			<v-row class="pt-5">
				<v-col cols="6" sm="3" md="3" v-if="!isEditing">
					<v-btn large depressed block class="bg-primary white--text rounded-lg" @click="isEditing = !isEditing">
						<v-icon>mdi-pencil</v-icon>
						<span class="pl-2">Ubah</span>
					</v-btn>
				</v-col>
				<v-col cols="6" sm="3" md="3" v-if="isEditing">
					<v-btn large depressed block class="bg-primary white--text rounded-lg" @click="save" :loading="btnLoadingProses" :disabled="btnLoadingProses">
						<v-icon>mdi-content-save-outline</v-icon>
						<span class="pl-2">Simpan</span>
					</v-btn>
				</v-col>
				<v-col cols="6" sm="3" md="3" v-if="isEditing">
					<v-btn large depressed block class="rounded-lg grey--text text--darken-2" color="grey lighten-2" @click="isEditing = !isEditing" :loading="btnLoadingProses" :disabled="btnLoadingProses">
						<v-icon>mdi-close</v-icon>
						<span class="pl-2">Batal</span>
					</v-btn>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
	components: {

	},
	data() {
		return {
			isEditing: null,
			joinDate: false,
			bornDate: false,
			btnLoadingProses: false,
			isActiveMember: false,
			member_name: '',
			member_birth_place: '',
			member_birth_date: '',
			member_address: '',
			member_city_id: '',
			member_province_id: '',
			member_gender: '',
			rules: {
				input: [
				v => !!v || 'Tidak boleh kosong',
				],
			},
		}
	},
	props: {
		data: { type: Object },
		province: { type: Array },
		city: { type: Array },
	},
	computed: {
		...mapState('option', ['provinces', 'cities'])
	},
	methods: {
		...mapActions('profile', ['getProfileMitra', 'getProfilePramitra', 'changePassword', 'editProfileMitra', 'editProfilePramitra']),
		...mapActions('option', ['getProvince', 'getCity']),

		changeProvince() {
			this.getCity({
				province_id: this.member_province_id
			})
			this.member_city_id = ''
		},
		async save() {
			if (this.$refs.formProfile.validate()) {
				this.btnLoadingProses = true
				let params = {
					name: this.member_name,
					email: this.data.member_email,
					mobilephone: this.data.member_mobilephone,
					birth_place: this.member_birth_place,
					birth_date: this.member_birth_date,
					province_id: this.member_province_id,
					city_id: this.member_city_id,
					address: this.member_address,
					member_gender: this.member_gender
				}

				if (this.isActiveMember) {
					await this.editProfileMitra(params).then(() => {
						this.getProfileMitra()
						this.btnLoadingProses = false
					}).catch(() => {
						this.btnLoadingProses = false
					})
				} else {
					await this.editProfilePramitra(params).then(() => {
						this.getProfileMitra()
						this.btnLoadingProses = false
					}).catch(() => {
						this.btnLoadingProses = false
					})
				}
				this.btnLoadingProses = false
				this.isEditing = !this.isEditing
			} else {
				this.btnLoadingProses = false
			}
		},
		setDataProfile(){
			this.member_name = this.data.member_name
			this.member_birth_place = this.data.member_birth_place
			this.member_birth_date = this.data.member_birth_date
			this.member_address = this.data.member_address
			this.member_province_id = this.data.member_province_id
			this.member_city_id = this.data.member_city_id
			this.member_gender = this.data.member_gender
		},

		async checkMemberActivation(data) {
			if (data.bin_network_id === "0" || data.bin_network_id === 0) this.isActiveMember = false
			else this.isActiveMember = true
		},
	},
	async mounted() {
		const authData = await localStorage.getItem('mlmcore-vo-auth-data');
		const data = await JSON.parse(authData)
		await this.checkMemberActivation(data)
		this.setDataProfile()
	},
};
</script>